import { StyledQrCodePopup } from './QrCodePopup.styled';
import { AppModal } from '../';
import { openUrl } from '../../utils';
import QRCode from "react-qr-code";

const QrCodePopup = ({ data: { label, url } }) => {
  return (
    <AppModal>
      <StyledQrCodePopup>
        <div style={{cursor: 'pointer', background: 'white', padding: '16px', maxWidth: '256px' }} onClick={() => openUrl(url)}>
          <QRCode
            size={224}
            style={{ height: "auto", maxWidth: "100%", width: "100%" }}
            value={url}
            viewBox={`0 0 224 224`}/>
        </div>
        <div className='qr-code-popup-label-wrapper'>
          <div className='qr-code-popup-label'>{label}</div>
          <img src='/assets/ar.svg' />
        </div>
      </StyledQrCodePopup>
    </AppModal>
  );
};

export default QrCodePopup;
